export enum UserRoles {
  NoAccess = 0,
  View = 1,
  Edit = 2,
  Submit = 3,
}
